import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import data from '../../../../assets/add-new-policy-request.json';
import { AppConfig } from '../../../../config/app-config';
import { POSTING_NOTICE_EXCEP_LABEL, PROGRAM_MENU, addNewPolicyAccordianData } from '../../../../treo.properties';
import { TreoDatepickerComponent } from '../../../components/treo-datepicker/treo-datepicker.component';

import { LoaderService } from '../../../../app/core/services/loading.service';
import { ProgramService } from '../programs.service';

import moment from 'moment';
import { CommonAgGridCellComponent } from '../../../../app/components/common-ag-grid-cell/common-ag-grid-cell.component';
@Component({
    selector: 'app-add-new-wc-posting-request',
    templateUrl: './add-new-wc-posting-request.component.html',
    styleUrls: ['./add-new-wc-posting-request.component.scss'],
    standalone: false
})
export class AddNewWCPostingRequestComponent implements OnInit {

    @ViewChild('accordion') accordion: QueryList<ElementRef>;

    postingNoticeStateExcepLabel = POSTING_NOTICE_EXCEP_LABEL;

    serviceRequestVOResponse: any;

    serviceRequestLabel = PROGRAM_MENU;

    addNewPolicyStateConfig = AppConfig.addNewPolicyStateConfig;
    addNewPolicySelectRequestConfig = AppConfig.addNewPolicySelectRequestConfig;
    addNewPolicyRequestTextAreaFieldConfig = AppConfig.addNewPolicyRequestTextAreaFieldConfig;
    selectedDate: Date;
    selectedDateList: any[] = []

    showCancelConfirmation: boolean = false;

    insuredAddressLine1InputConfig = AppConfig.insuredAddressLine1InputConfig;
    insuredAddressLine2InputConfig = AppConfig.insuredAddressLine2InputConfig;
    insuredCityNameInputConfig = AppConfig.insuredCityNameInputConfig;
    addNewPolicyInsuredStateConfig = AppConfig.addNewPolicyInsuredStateConfig;
    insuredZipcodeInputConfig = AppConfig.insuredZipcodeInputConfig;
    claimRepNumInputConfig = AppConfig.claimRepNumInputConfig;
    feinInputConfig = AppConfig.feinInputConfig;
    tpaNameInputConfig = AppConfig.tpaNameInputConfig;

    insuredNameInputConfig = AppConfig.insuredNameInputConfig;
    companyNameInputConfig = AppConfig.companyNameInputConfig;
    addressLine1InputConfig = AppConfig.addressLine1InputConfig;
    addressLine2InputConfig = AppConfig.addressLine2InputConfig;
    cityNameInputConfig = AppConfig.cityNameInputConfig;
    zipcodeInputConfig = AppConfig.zipcodeInputConfig;
    phoneNumberInputConfig = AppConfig.phoneNumberInputConfig;
    extensionInputConfig = AppConfig.extensionInputConfig;
    recipientMailInputConfig = AppConfig.recipientMailInputConfig;
    addNewPolicyDatePickerConfig = AppConfig.addNewPolicyDatePickerConfig;
    addNewPolicyServiceRequestFormGroup: UntypedFormGroup;
    dateNeededDatePickerConfig = AppConfig.dateNeededDatePickerConfig;

    totalPaperCountInputConfig = AppConfig.totalPaperCountInputConfig;
    totalEmailCountInputConfig = AppConfig.totalEmailCountInputConfig;
    postingNoticeEmailAddInputConfig = AppConfig.postingNoticeEmailAddInputConfig;
    commentsTextAreaFieldConfig = AppConfig.commentsTextAreaFieldConfig;

    paginationPageSizeReqDetails = 10;
    paginationPageSizeSelectorReqDetails: any[];
    totalRows = 0;
    reqDetailsTableData: any[] = [];
    inputtedNoOfPaperCopies = {};
    totalInputtedNoOfPaperCopies = 0;
    inputtedNoOfEmailCopies = {};
    totalInputtedNoOfEmailCopies = 0;
    requestDetailsColumnDefs: ColDef[] = [
        {
            headerName: ' NAME INSURED ',
            field: 'namedInsured',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator ',
            width: 200
        },
        {
            headerName: 'POLICY NUMBER ',
            field: 'policyNumber',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'POLICY PERIOD ',
            field: 'term',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            width: 200
        },
        {
            headerName: 'STATE ',
            field: 'stateDescription',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1,
            cellRenderer: CommonAgGridCellComponent,
            cellRendererParams: { tempType: 'addNewWCPosting' },


        },
        {
            headerName: '# OF PAPER COPIES',
            field: 'noOfPaperCopies',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1,
            cellRenderer: (params: any) => {
                const input = document.createElement('input');
                const state = params.data.stateDescription;
                input.className = 'form-control w-50';
                input.id = `papercopyinput_${params?.data?.stateDescription}${params?.node?.rowIndex}`;

                input.type = 'text';

                input.maxLength = 5

                input.value = this.inputtedNoOfPaperCopies['papercopies_' + params?.node?.rowIndex] ?? '';

                // Allow only digits and limit to 5 characters
                input.addEventListener('input', (event: any) => {
                    input.value = input.value.replace(/\D/g, '').slice(0, 5);
                });
                input.addEventListener('change', (event: any) => this.onPaperCopiesInputChange(event, params?.node?.rowIndex));

                return (params?.data?.stateDescriptionWithExcep?.toLowerCase()?.includes('n/a')) ? '' :
                    (this.serviceRequestVOResponse?.wcNotAvailableSttList?.includes(state)) ? '' : input
            }
        },
        {
            headerName: '# OF EMAIL COPIES',
            field: 'noOfEmailCopies',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1,
            cellRenderer: (params: any) => {
                const input = document.createElement('input');
                const state = params.data.stateDescription

                input.type = 'text';
                input.maxLength = 5;
                input.className = 'form-control w-50';
                input.id = `emailcopyinput_${params?.data?.stateDescription}${params?.node?.rowIndex}`;
                input.value = this.inputtedNoOfEmailCopies['emailcopies_' + params?.node?.rowIndex] ?? '';
                // Allow only digits and limit to 5 characters
                input.addEventListener('input', (event: any) => {
                    input.value = input.value.replace(/\D/g, '').slice(0, 5);
                });
                input.addEventListener('change', (event: any) => this.onEmailCopiesInputChange(event, params?.node?.rowIndex));
                return (params?.data?.stateDescriptionWithExcep?.toLowerCase()?.includes('n/a')) ? '' :
                    (this.serviceRequestVOResponse?.emailNASttList?.includes(state)) ? '' : input;
            }
        },
        {
            headerName: 'WRITING CO',
            field: 'writingCompanyCode',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        }
    ];

    paginationPageSizeAddReceipents = 10;
    paginationPageSizeSelectorAddReceipents: any[];
    totalRows2 = 0;
    gridApi2: any;
    selectedReceipents: any[] = [];
    additionalReceipentsTableData: any[] = [];
    additionalRecipientsColumnDefs: ColDef[] = [
        {
            headerName: '',
            field: '',
            width: 60,
            checkboxSelection: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: false
        },
        {
            headerName: ' USER OF THIS ACCOUNT ',
            field: 'name',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator ',
            flex: 1
        },
        {
            headerName: ' ROLE ',
            field: 'role',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator ',
            flex: 1
        },
    ];

    @ViewChild('reportedEmployerDatePickerStart') reportedEmployerDatePickerStart: TreoDatepickerComponent;
    @ViewChild('requestDetailsTextArea') requestDetailsTextArea: TreoDatepickerComponent;
    @ViewChild('dateNeededPicker') dateNeededPicker: TreoDatepickerComponent;

    accordionGridData = data.claimsList.config.dataSource1;
    accordionGridHeader = data.claimsList.config.columnHeaders1;
    accordianData = addNewPolicyAccordianData;

    public fieldArray: [{}] = [{ index: 0 }];
    public newAttribute: any = {};
    gridApi: any;
    gridApi1: any;
    showEndFileAttachment: boolean = false;

    public defaultColDef: ColDef = {
        resizable: false,
        autoHeight: true,
        wrapText: true,
        wrapHeaderText: true
    };

    isStateSelectionValid: boolean = true;
    isInsuredStateSelectionValid: boolean = true;
    isRequestDetailsValid: boolean = true;
    isPostingNoticeEmailAddressValid: boolean = true;
    isPostingNoticeEmailAddress: boolean = true;
    formattedDateNeeded: any;
    selectedFileName: string = '';
    maxFiles: number = 2;
    filesArray: any[] = [{ name: '' }];
    uploadedFiles: File[] = [];
    validUploadedFiles: File[] = [];
    @ViewChildren('fileInputRefs') fileInputRefs: QueryList<ElementRef>;
    public JSON = JSON;

    constructor(private fb: UntypedFormBuilder, private router: Router, public loaderService: LoaderService, public programsService: ProgramService) { }

    ngOnInit() {
        this.addNewPolicyServiceRequestFormGroup = this.fb.group({
            insuredNameInput: [''],
            recipientMailInput: [''],
            feinInput: [''],
            companyNameInput: [''],
            claimRepNumInput: [''],
            dateNeededDatePicker: [''],
            addressLine1Input: [''],
            addressLine2Input: [''],
            cityNameInput: [''],
            zipCodeInput: [''],
            phoneNumberInput: [''],
            extensionInput: [''],
            addNewPolicyState: ['', Validators.required],
            insuredAddressLine1Input: [''],
            insuredAddressLine2Input: [''],
            insuredCityNameInput: [''],
            addNewPolicyInsuredState: ['', Validators.required],
            insuredZipCodeInput: [''],
            tpaInput: ['', [Validators.pattern('^[a-zA-Z0-9 .,-]*$')]],
            totalPaperCountInput: [''],
            totalEmailCountInput: [''],
            postingNoticeEmailAddress: [''],
            commentsTextAreaField: ['']

        })
        this.populateStates();
        this.getPageLoadData();
        this.fetchAddReceipentsTableData();
    }

    populateStates() {
        this.loaderService.showLoader();
        const payload = {
            actionType: "SERVICE_REQUEST",
            operation: "SR_INIT_PARAMS",
            organizationId: this.loaderService.getItem('orgId'),
            applicationAccntDtlId: null,
            sttdId: 18
        };
        this.programsService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                const states = resp?.statesVoList.map(item => {
                    return {
                        value: item.sttAbbrvtn,
                        label: item.sttDscrptn
                    };
                }).filter(item => item.value && item.label);

                this.addNewPolicyStateConfig.options = [
                    { value: '', label: 'Please Select' },
                    ...states
                ];

                this.addNewPolicyInsuredStateConfig.options = [
                    { value: '', label: 'Please Select' },
                    ...states
                ];
            },
            error: () => {
                this.loaderService.hideLoader();
            }
        });
    }

    getPageLoadData() {
        this.loaderService.showLoader();
        const payload = {
            actionType: "SERVICE_REQUEST",
            operation: "FETCH_WC_INFORMATION",
            organizationId: this.loaderService.getItem('orgId'),
            applicationAccntDtlId: null
        };
        this.programsService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                this.serviceRequestVOResponse = resp.serviceRequestVO;
                this.prefillFormWithData();
            },
            error: () => {
                this.loaderService.hideLoader();
            }
        });
    }

    formatReqDetailsTableData() {
        this.reqDetailsTableData = this.serviceRequestVOResponse.requestDetailVO.reduce((acc, curr) => {
            const exists = acc.find(item =>
                item.namedInsured === curr.namedInsured &&
                item.policyNumber === curr.policyNumber &&
                item.term === curr.term
            );

            if (exists) {
                acc.push({
                    ...curr,
                    namedInsured: '',
                    policyNumber: '',
                    term: ''
                });
            } else {
                acc.push(curr);
            }

            return acc;
        }, []);
    }

    populateReqDetailsTableData() {
        this.formatReqDetailsTableData();
        this.totalRows = this.reqDetailsTableData.length;
        this.paginationPageSizeReqDetails = 10;
        this.paginationPageSizeSelectorReqDetails = [];
        this.pageSizeOptions();
    }

    fetchAddReceipentsTableData() {
        this.loaderService.showLoader();
        const payload = {
            actionType: "SERVICE_REQUEST",
            operation: "RECIPIENTS",
            organizationId: this.loaderService.getItem('orgId'),
            applicationAccntDtlId: null
        };
        this.programsService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                this.additionalReceipentsTableData = resp?.recipients ?? [];
                this.totalRows2 = this.additionalReceipentsTableData.length;
                this.paginationPageSizeAddReceipents = 10;
                this.paginationPageSizeSelectorAddReceipents = [];
                this.pageSizeOptionsAddReceipents();
            },
            error: () => {
                this.loaderService.hideLoader();
            }
        });
    }

    prefillFormWithData() {
        this.populateReqDetailsTableData();
        this.prefillContactInfo();
    }

    prefillContactInfo() {

        if (this.serviceRequestVOResponse) {
            const insuredName = this.serviceRequestVOResponse?.insuredName || '';
            const company = this.serviceRequestVOResponse?.company || '';
            const addressLn1 = this.serviceRequestVOResponse?.addressLn1 || '';
            const addressLn2 = this.serviceRequestVOResponse?.addressLn2 || '';
            const city = this.serviceRequestVOResponse?.city || '';
            const zipCode = this.serviceRequestVOResponse?.zipCode || '';
            const phoneNumber = this.serviceRequestVOResponse?.phoneNumber || '';
            const ext = this.serviceRequestVOResponse?.ext || '';
            const mailingRecipient = this.serviceRequestVOResponse?.mailingRecipient || '';
            const stateCode = this.serviceRequestVOResponse?.stateCode || '';
            const dateNeeded = this.serviceRequestVOResponse?.dateNeeded || '';
            const fein = this.serviceRequestVOResponse?.insuredFein || '';
            const insuredAddressLine1 = this.serviceRequestVOResponse?.insuredAddressLn1 || '';
            const insuredAddressLine2 = this.serviceRequestVOResponse?.insuredAddressLn2 || '';
            const insuredCity = this.serviceRequestVOResponse?.insuredCity || '';
            const insuredStateCode = this.serviceRequestVOResponse?.insuredStateCode || '';
            const insuredZipcode = this.serviceRequestVOResponse?.insuredZipCode || '';
            const tpaName = this.serviceRequestVOResponse?.tpaName || '';
            const postingNoticeEmailAddress = this.serviceRequestVOResponse?.postingEmailAddress || '';
            const postingComment = this.serviceRequestVOResponse?.postinComment || '';

            const formattedDate = dateNeeded ? moment(dateNeeded).format('MM/DD/YYYY') : '';

            this.addNewPolicyServiceRequestFormGroup.patchValue({
                insuredNameInput: insuredName,
                recipientMailInput: mailingRecipient,
                feinInput: fein,
                companyNameInput: company,
                dateNeededDatePicker: formattedDate,
                addressLine1Input: addressLn1,
                addressLine2Input: addressLn2,
                cityNameInput: city,
                zipCodeInput: zipCode,
                phoneNumberInput: phoneNumber,
                extensionInput: ext,
                addNewPolicyState: stateCode,
                insuredAddressLine1Input: insuredAddressLine1,
                insuredAddressLine2Input: insuredAddressLine2,
                insuredCityNameInput: insuredCity,
                addNewPolicyInsuredState: insuredStateCode,
                insuredZipCodeInput: insuredZipcode,
                tpaInput: tpaName,
                postingNoticeEmailAddress: postingNoticeEmailAddress,
                commentsTextAreaField: postingComment

            });

            this.dateNeededPicker.date = formattedDate;
        }

    }

    sendRequest() {
        this.validateForm();
        if (this.addNewPolicyServiceRequestFormGroup.valid && this.dateNeedErr === false) {
            this.formSubmit();
        }
    }
    getApplicationId() {
        const encodedId = this.loaderService.getItem('appAccountDetailId');
        if (!encodedId) return null;

        const decodedId = encodedId;
        return Number(decodedId) === 0 ? null : decodedId;
    }

    formSubmit() {
        this.loaderService.showLoader();
        const formValues = this.addNewPolicyServiceRequestFormGroup.getRawValue();
        const requestDt = moment(this.serviceRequestVOResponse?.requestDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
        const payload = {
            actionType: "CREATE_WC_SERVICE_REQUEST",
            organizationId: this.loaderService.getItem('orgId'),
            applicationAccntDtlId: this.getApplicationId(),
            serviceRequestVO: {
                postinComment: formValues.commentsTextAreaField,
                policyNumber: formValues.claimRepNumInput,
                insuredFein: formValues.feinInput,
                requestDate: requestDt,
                requestedBy: this.serviceRequestVOResponse?.requestedBy,
                insuredName: formValues.insuredNameInput,
                dateNeeded: this.formattedDateNeeded ?? '',
                insuredCity: formValues.insuredCityNameInput,
                insuredAddressLn1: formValues.insuredAddressLine1Input,
                insuredAddressLn2: formValues.insuredAddressLine2Input,
                insuredStateCode: formValues.addNewPolicyInsuredState,
                insuredZipCode: formValues.insuredZipCodeInput,
                mailingRecipient: formValues.recipientMailInput,
                company: formValues.companyNameInput,
                addressLn1: formValues.addressLine1Input,
                addressLn2: formValues.addressLine2Input,
                city: formValues.cityNameInput,
                stateCode: formValues.addNewPolicyState,
                zipCode: formValues.zipCodeInput,
                phoneNumber: formValues.phoneNumberInput,
                ext: formValues.extensionInput,
                tpaName: formValues.tpaInput,
                postingEmailAddress: formValues.postingNoticeEmailAddress,
                requestDetailVO: []
            }
        };

        this.enteredReqDetailsIndexeArr.forEach((index) => {
            const item = this.serviceRequestVOResponse.requestDetailVO[index];
            if (item) {
                const noOfPaperCopies = this.inputtedNoOfPaperCopies['papercopies_' + index] || 0;
                const noOfEmailCopies = this.inputtedNoOfEmailCopies['emailcopies_' + index] || 0;
                const [effectiveDate, expirationDate] = (item?.term) ? item?.term?.split(' - ').map(date => moment(date, 'MM/DD/YYYY').utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')) : [];
                payload.serviceRequestVO.requestDetailVO.push({
                    policyNumber: item.policyNumber,
                    effectiveDate: effectiveDate,
                    expirationDate: expirationDate,
                    stateDescription: item.stateDescription,
                    writingCompanyCode: item.writingCompanyCode,
                    paperCopyNumber: noOfPaperCopies,
                    emailCopyNumber: noOfEmailCopies
                });
            }
        });

        if (this.selectedReceipents.length > 0) {
            payload["recipients"] = this.selectedReceipents;
        }

        this.programsService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                this.callUploadAttachmentsAPI(resp);
            },
            error: () => {
                this.loaderService.hideLoader();
            }
        });
    }

    callUploadAttachmentsAPI(resp: any) {

        const srvcRqstId = resp.serviceRequest[0];
        const srvcRqstNum = resp.serviceRequest[1];
        this.validUploadedFiles = this.filesArray.filter(file => file instanceof File);
        if (this.validUploadedFiles.length > 0) {
            this.loaderService.showLoader();
            this.programsService.uploadFile(this.validUploadedFiles, srvcRqstId, srvcRqstNum).subscribe({
                next: (resp: any) => {
                    this.loaderService.hideLoader();
                    this.router.navigate([`/program/service-requests`]);
                },
                error: () => {
                    this.loaderService.hideLoader();
                }
            });
        } else {
            this.router.navigate([`/program/service-requests`]);
        }
    }

    addFile() {
        if (this.filesArray.length < this.maxFiles) {
            this.filesArray.push({ name: '' });
        }
    }

    triggerFileInputClick(index: number): void {
        const fileInput = this.fileInputRefs.toArray()[index]?.nativeElement;
        if (fileInput) {
            fileInput.click();
        }
    }

    uploadFile(event: Event, index: number): void {
        const inputElement = this.fileInputRefs.toArray()[index]?.nativeElement;
        if (inputElement) {
            const file = (event.target as HTMLInputElement).files?.[0];
            const allowedTypes = ['doc', 'docm', 'docx', 'dot', 'htm', 'mdi', 'msg', 'pdf', 'rtf', 'tif', 'txt', 'xls', 'xlsx', 'zip'];
            const fileExtension = file?.name?.split('.')?.pop()?.toLowerCase();
            if (file && allowedTypes.includes(fileExtension)) {
                this.filesArray[index] = file;
            }
        }
    }

    /* paper copies */

    calculatePaperCopiesTotal() {
        this.totalInputtedNoOfPaperCopies = 0;
        Object.values(this.inputtedNoOfPaperCopies).forEach((value: any) => {
            const numericValue = parseInt(value, 10);
            if (!isNaN(numericValue)) {
                this.totalInputtedNoOfPaperCopies += numericValue;
            }
        });
    }

    updatePaperCopiesTotal() {
        this.calculatePaperCopiesTotal();
        this.addNewPolicyServiceRequestFormGroup.patchValue({
            totalPaperCountInput: this.totalInputtedNoOfPaperCopies
        });
    }

    onPaperCopiesInputChange(event: any, rowIndex: number) {
        const value = event.target.value;
        this.inputtedNoOfPaperCopies['papercopies_' + rowIndex] = value;
        this.updatePaperCopiesTotal();
    }

    /* email copies */

    calculateEmailCopiesTotal() {
        this.totalInputtedNoOfEmailCopies = 0;
        Object.values(this.inputtedNoOfEmailCopies).forEach((value: any) => {
            const numericValue = parseInt(value, 10);
            if (!isNaN(numericValue)) {
                this.totalInputtedNoOfEmailCopies += numericValue;
            }
        });
    }

    updateEmailCopiesTotal() {
        this.calculateEmailCopiesTotal();
        this.addNewPolicyServiceRequestFormGroup.patchValue({
            totalEmailCountInput: this.totalInputtedNoOfEmailCopies
        });
    }

    onEmailCopiesInputChange(event: any, rowIndex: number) {
        const value = event.target.value;
        this.inputtedNoOfEmailCopies['emailcopies_' + rowIndex] = value;
        this.updateEmailCopiesTotal();
    }



    formatPhoneNumber($event: any) {
        const input = $event.target;
        let value = input.value.replace(/\D/g, ''); // Remove all non-numeric characters

        if (value.length > 10) {
            value = value.substring(0, 10); // Limit to 10 digits
        }

        if (value.length > 0) {
            value = value.replace(/^(\d{3})(\d{0,3})(\d{0,4})$/, (_, p1, p2, p3) => {
                if (p3) {
                    return `(${p1}) ${p2}-${p3}`;
                } else if (p2) {
                    return `(${p1}) ${p2}`;
                } else {
                    return `(${p1}`;
                }
            });
        }

        input.value = value;
    }

    validatePhoneNumberOnBlur($event: any, controKey: string) {
        const input = $event.target;
        const value = input.value;
        // Check if the value matches the (123) 456-7890 format
        const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
        if (!phoneRegex.test(value)) {
            input.value = ''; // Clear the input if it doesn't match the format
            this.addNewPolicyServiceRequestFormGroup.get(controKey).setValue('');
        }
    }

    get enteredReqDetailsIndexeArr() {
        return Array.from(
            new Set([
                ...Object.keys(this.inputtedNoOfPaperCopies).map(key => key.split('_')[1]),
                ...Object.keys(this.inputtedNoOfEmailCopies).map(key => key.split('_')[1])
            ])
        )
            .map(index => parseInt(index, 10))
            .sort((a, b) => a - b);
    }

    dateChange(event: any) {
        this.dateNeedErr = false
        const data: Date | null = event?.detail?.valueAsDate;
        const formattedDate = moment.utc(data).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
        this.formattedDateNeeded = formattedDate;
        const todayDate = moment.utc().startOf('day');
        if (data) {
            const selectedDate = moment.utc(data).startOf('day');
            if (selectedDate.isBefore(todayDate)) {
                this.dateNeedErr = true
            } else {
                this.dateNeededPicker.setError(null)
                this.dateNeededPicker.setMessage('')
                this.dateNeedErr = false
            }
        } else {
            this.dateNeededPicker.setError(null)
            this.dateNeededPicker.setMessage('')
            this.dateNeedErr = false
        }
    }

    dateNeedErr = false

    validateForm() {
        const formValues = this.addNewPolicyServiceRequestFormGroup.getRawValue();
        const addNewPolicyStateControl = this.addNewPolicyServiceRequestFormGroup.get('addNewPolicyState');
        if (!formValues.addNewPolicyState) {
            addNewPolicyStateControl.setErrors({ required: true });
            this.isStateSelectionValid = false;
        } else {
            addNewPolicyStateControl.setErrors(null);
            this.isStateSelectionValid = true;
        }
        addNewPolicyStateControl.markAsTouched();
        addNewPolicyStateControl.markAsDirty();

        const addNewPolicyInsuredStateControl = this.addNewPolicyServiceRequestFormGroup.get('addNewPolicyInsuredState');
        if (!formValues.addNewPolicyInsuredState) {
            addNewPolicyInsuredStateControl.setErrors({ required: true });
            this.isInsuredStateSelectionValid = false;
        } else {
            addNewPolicyInsuredStateControl.setErrors(null);
            this.isInsuredStateSelectionValid = true;
        }
        addNewPolicyInsuredStateControl.markAsTouched();
        addNewPolicyInsuredStateControl.markAsDirty();
        /* if any of fields missing */
        if (this.isStateSelectionValid && this.isInsuredStateSelectionValid) {
            if (!formValues.commentsTextAreaField && (formValues.totalPaperCountInput === '' || formValues.totalPaperCountInput === 0 || formValues.totalPaperCountInput === null || formValues.totalPaperCountInput === undefined) && (formValues.totalEmailCountInput === '' || formValues.totalEmailCountInput === 0 || formValues.totalEmailCountInput === null || formValues.totalEmailCountInput === undefined)) {
                this.addNewPolicyServiceRequestFormGroup.get('commentsTextAreaField').setErrors({ required: true });
                this.addNewPolicyServiceRequestFormGroup.get('totalPaperCountInput').setErrors({ required: true });
                this.addNewPolicyServiceRequestFormGroup.get('totalEmailCountInput').setErrors({ required: true });
                this.isRequestDetailsValid = false;
            } else {
                this.addNewPolicyServiceRequestFormGroup.get('commentsTextAreaField').setErrors(null);
                this.addNewPolicyServiceRequestFormGroup.get('totalPaperCountInput').setErrors(null);
                this.addNewPolicyServiceRequestFormGroup.get('totalEmailCountInput').setErrors(null);
                this.isRequestDetailsValid = true;
            }
        }

        /* if email address invalid */
        const postingNoticeEmailAddressControl = this.addNewPolicyServiceRequestFormGroup.get('postingNoticeEmailAddress');
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (this.isRequestDetailsValid && formValues.postingNoticeEmailAddress && !emailRegex.test(formValues.postingNoticeEmailAddress)) {
            postingNoticeEmailAddressControl.setErrors({ invalidEmail: true });
            this.isPostingNoticeEmailAddressValid = false;
        } else {
            postingNoticeEmailAddressControl.setErrors(null);
            this.isPostingNoticeEmailAddressValid = true;
        }
        if (formValues.totalEmailCountInput !== '' && formValues.totalEmailCountInput !== 0 && !formValues.postingNoticeEmailAddress) {
            postingNoticeEmailAddressControl.setErrors({ required: true });
            this.isPostingNoticeEmailAddress = false;
        } else {
            postingNoticeEmailAddressControl.setErrors(null);
            this.isPostingNoticeEmailAddress = true;
        }
        postingNoticeEmailAddressControl.markAsTouched();
        postingNoticeEmailAddressControl.markAsDirty();


    }

    onCellClicked(event: any) {
    }

    onGridReadyReqDetails(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridApi.hideOverlay();
    }

    pageSizeOptions() {
        let maxRange = this.totalRows <= 500 ? this.totalRows + 10 : 500;
        maxRange = this.checkMaxRange(maxRange);
        for (let i = 10; i <= maxRange; i += 10) {
            this.paginationPageSizeSelectorReqDetails.push(i);
        }
    }

    checkMaxRange(maxRange?: number) {
        if (maxRange % 10 === 0 && maxRange != 500) {
            maxRange = maxRange - 10;
        }
        return maxRange;
    }

    /* additional Receipeents */

    onCellClickedAddRecp(event: any) {
        console.log('Cell clicked in additional recipients grid:', event);
    }

    onSelectionChangedAddReceipents() {
        this.selectedReceipents = this.gridApi2.getSelectedRows();
    }

    onGridReadyAddReceipents(params: GridReadyEvent) {
        this.gridApi2 = params.api;
        this.gridApi2.hideOverlay();
    }
    pageSizeOptionsAddReceipents() {
        let maxRange = this.totalRows2 <= 500 ? this.totalRows2 + 10 : 500;
        maxRange = this.checkMaxRangeAddReceipents(maxRange);
        for (let i = 10; i <= maxRange; i += 10) {
            this.paginationPageSizeSelectorAddReceipents.push(i);
        }
    }
    checkMaxRangeAddReceipents(maxRange?: number) {
        if (maxRange % 10 === 0 && maxRange != 500) {
            maxRange = maxRange - 10;
        }
        return maxRange;
    }

    proceedWithCancel() {
        this.router.navigate([`/program/service-requests`]);
    }

    cancelForm(): void {
        if (
            this.addNewPolicyServiceRequestFormGroup?.dirty
        ) {
            this.showCancelConfirmation = true;

        }
        else {
            this.router.navigate([`/program/service-requests`]);
        }
    }
    confirmationcancel() {
        this.showCancelConfirmation = false;
    }

    formateDate(date: any, isUTC?: boolean) {
        if (!date) {
            return '';
        }
        const formattedDate = isUTC ? moment(date).format('MM/DD/YYYY') : moment(date).utc().format('MM/DD/YYYY');
        return formattedDate
    }

}
